// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"b85b6273","365":"8d88a137","488":"103fcd25"}[chunkId] + ".chunk.js";
};